import React, { useState, useEffect } from "react";  // Importing useState and useEffect
import { Container, Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MetaManager from "../MetaManager";
import OtherServicesCarousel from "../OtherServicesCarousel";
import CallToAction from "../Home/CallToAction/CallToAction";
import BannerForm from './BannerForm';
import Faq from "./Faq";
import './Services.css';
const StickersAndLabels = () => {
  const servicesFaqData = [
    {
      question:
        "What customisation options are available for stickers and labels?",
      answer:
        "Printingy offers extensive customisation options for stickers and label printing, including sizes, shapes, materials, and finishes. Our custom sticker label design and printing services allow you to incorporate logos, colours, and unique layouts that align with your branding. We also provide options for waterproof, scratch-resistant, and eco-friendly materials to suit various applications.",
    },
    {
      question: "Does Printingy handle bulk orders for stickers and labels?",
      answer:
        "Yes, Printingy specialises in bulk product label sticker printing and custom sticker orders. Bulk printing ensures consistent quality across all items while offering cost-effective solutions for businesses. Our efficient production processes and advanced technology guarantee reliable and timely delivery for large-scale needs.",
    },
    {
      question:
        "What industries benefit from stickers and label printing services?",
      answer:
        "Stickers and labels are widely used across retail, manufacturing, food and beverage, and event management industries. Businesses use stickers and label printing for product packaging, promotional campaigns, and corporate branding. Printingy tailors its solutions to meet the unique needs of each industry, ensuring professional and impactful results.",
    },
    {
      question:
        "What materials and finishes are available for stickers and labels?",
      answer:
        "We use high-quality product label sticker printing materials, including vinyl, paper, and eco-friendly options. Finishes such as matte, glossy, or UV coating enhance your stickers and labels' durability and visual appeal. These materials ensure your products maintain a professional look and withstand various conditions, such as moisture or heat.",
    },
    {
      question:
        "Does Printingy provide design assistance for stickers and labels?",
      answer:
        "Our custom sticker label design and printing services include professional design assistance. Whether you have a concept in mind or need creative input, our design team works with you to create visually engaging and functional stickers and labels. From font selection to colour schemes, we ensure every detail aligns with your brand and purpose.",
    },
    {
      question:
        "What is the typical turnaround time for stickers and label printing?",
      answer:
        "Turnaround times for printing stickers and labels depend on the order's size and complexity. Standard bulk orders are typically completed within a few business days. For highly customised designs or larger volumes, we provide clear timelines and prioritise meeting your deadlines without compromising quality.",
    },
    {
      question:
        "Are eco-friendly options available for sticker and label printing?",
      answer:
        "Printingy is committed to sustainability and offers eco-friendly options for custom sticker label design and printing. We use recyclable materials and non-toxic inks to minimise environmental impact. These options are ideal for businesses aligning their branding with eco-conscious values.",
    },
    {
      question:
        "What factors should I consider when ordering custom stickers and labels?",
      answer:
        "Consider the purpose, audience, and application when ordering custom sticker label design and printing. Choosing the right material, size, and design elements ensures your stickers and labels are effective and visually appealing. Printingy’s team guides the process to help you create products that achieve your goals.",
    },
    {
      question: "How do I place an order for stickers and label printing?",
      answer:
        "Placing an order is simple and efficient. Visit our website and select your preferences for stickers and label printing. Upload your design files or share your requirements, and our team will guide you through the process. We ensure a seamless experience from design approval to delivery.",
    },
    {
      question: "What makes bulk sticker and label printing cost-effective?",
      answer:
        "Bulk sticker and label printing reduces per-unit costs, making it an economical choice for large-scale needs. Printingy delivers high-quality results at competitive prices by consolidating materials and streamlining production. Our bulk product label sticker printing services ensure exceptional value while maintaining professional standards.",
    },
  ];

  const [pageTitle, setPageTitle] = useState('Stickers and Labels');  // Dynamic title state

  useEffect(() => {
    document.title = pageTitle; // Set the document title dynamically
  }, [pageTitle]); // This will run whenever the pageTitle changes

  return (
    <div>
      <MetaManager
        title="Custom Sticker and Label Printing Services"
        description="Professional stickers and label printing for businesses. Bulk product label sticker printing and custom sticker label design and printing solutions."
        keywords="Stickers labels printing ,Product label sticker printing, Custom sticker label design and printing
"
      />

      <header className="services-header text-center py-5  serviceheader">
        <Container>
          <Row className="align-item-cen">
            <Col lg={6}>
              <h1>Professional Stickers and Labels Printing</h1>
              <h2 className="text-muted">
                Custom sticker labels design and printing for businesses{" "}
              </h2>
            </Col>

            {/* Contact Form on the Right Side */}
            <Col lg={6}>
              <div
                className="contact-form p-4 bg-white shadow-sm rounded"
                style={{ maxWidth: "400px", margin: "auto" }}
              >
                <h3 className="text-center mb-4">Get in Touch</h3>
                <BannerForm />
              </div>
            </Col>
          </Row>
        </Container>
      </header>

      <section className="services-overview ">
        <Container>
          <p>
            Stickers and labels are essential for branding, packaging, and
            product identification. Printingy offers premium stickers and label
            printing services to meet your business needs. Our expertise
            includes product label sticker printing and custom sticker label
            design and printing, ensuring professional and tailored solutions.
          </p>
          <p>
            Our stickers and labels are crafted with precision and durability,
            whether for retail products, promotional materials, or corporate
            branding. With options for waterproof, scratch-resistant, and
            eco-friendly materials, our printing solutions cater to diverse
            applications.
          </p>
          <p>
            From sleek designs to vibrant prints, Printingy ensures that every
            sticker and label reflects your brand identity and meets your
            functional requirements. Trust us for bulk orders that deliver
            consistent quality and help your business stand out.
          </p>
        </Container>
      </section>

      <section className="why-choose py-5">
        <Container>
          <h2 className="text-center mb-4">Why Choose Printingy</h2>

          {/* Custom Flyer Printing Experts */}
          <div className="py-4 px-3 rounded mb-4">
            <Row className="al-center">
              <Col lg={6}>
                <h2 className="small-hed">
                  Reliable Stickers and Labels Printing Services
                </h2>
                <h3 className="large-hed">
                  High-quality, affordable, and customisable printing solutions
                </h3>

                <ul className="list-unstyled">
                  <li>
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success me-2"
                    />
                    Expert custom sticker label design and printing for unique
                    branding.
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success me-2"
                    />
                    Professional product label sticker printing for retail and
                    packaging needs.
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success me-2"
                    />
                    Bulk printing options for cost-effective solutions.
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success me-2"
                    />
                    Durable materials with waterproof, scratch-resistant, and
                    eco-friendly options.
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success me-2"
                    />
                    Vibrant colours and sharp text for professional results.
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success me-2"
                    />
                    Quick turnarounds and efficient order management systems.
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success me-2"
                    />
                    Trusted by retail businesses, manufacturers, and event
                    organisers nationwide.
                  </li>
                  <li>
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="text-success me-2"
                    />
                    Competitive pricing for large-scale orders without
                    compromising quality.
                  </li>
                </ul>
                <Button variant="primary" className="mt-3">
                  Contact Us
                </Button>
              </Col>

              {/* Contact Form on the Right Side */}
              <Col lg={6}>
                <img
                  src="/assets/img/stickersprints.jpg" // Path relative to the public folder
                  alt="Bulk custom sticker label design and printing"
                  className="img-fluid rounded"
                />
              </Col>
            </Row>
          </div>
          <CallToAction
            title="Connect with us Today"
            description="Your trusted Partner for Bulk Printing Solutions..!"
          />
          {/* Professional Flyer Printing with Precision */}
          <div className="shadow-sm p-4 rounded">
            <h2 className="large-hed">
              Premium Stickers and Labels Delivered On Time{" "}
            </h2>
            <h3 className="small-hed">
              Focus on your business while we handle your sticker and label
              printing needs{" "}
            </h3>
            <p>
              At Printingy, we combine advanced printing technology and design
              expertise to deliver exceptional stickers and label printing
              services. Whether you need product label sticker printing for
              packaging or custom designs for promotional campaigns, we ensure
              precision and quality in every print.
            </p>
            <p>
              Our streamlined processes and commitment to efficiency guarantee
              timely delivery for bulk orders, ensuring your materials are ready
              when needed. Partner with Printingy for professional stickers and
              labels that leave a lasting impression.
            </p>
          </div>
        </Container>
      </section>

      <div>
        {/* Existing Content */}
        <OtherServicesCarousel />
        {/* Other Content */}
      </div>

      <Faq faqData={servicesFaqData} />
    </div>
  );
};

export default StickersAndLabels;
